export class NatureCustomData {
  id?: number;
  natureCustomFieldId?: number;
  textValue?: string;
  numberValue?: number;
  decimalValue?: number;
  dateValue?: string;
  listValueItemId?: number;
}
